import { render, staticRenderFns } from "./customerList.vue?vue&type=template&id=38db76ae&scoped=true&"
import script from "./customerList.vue?vue&type=script&lang=js&"
export * from "./customerList.vue?vue&type=script&lang=js&"
import style0 from "./customerList.vue?vue&type=style&index=0&id=38db76ae&scoped=true&lang=css&"
import style1 from "./customerList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db76ae",
  null
  
)

export default component.exports